import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import { Icon } from '@winnin/winnin_ui.components.icon'
import { Image } from '@winnin/winnin_ui.components.image'
import { Title } from '@winnin/winnin_ui.components.title'

import { GRAPH_COLORS } from 'consts'
import { useSelectedItemsList } from 'contexts/SelectedItemsListProvider'
import { GLOBAL_TAXONOMY_TERRITORY_TYPES } from 'modules/global-topic/common/global-topic.consts'
import { PanelStore } from 'stores'
import { makeUrlTo } from 'utils'
import { getRoute } from 'utils/routes'
import { PATHNAMES } from 'utils/routes/consts'

import CardSubtitle from '../CardSubtitle'

import './index.scss'

const getCurrentUrl = (item, workspaceId) => {
  const getLinkFromRoute = ({ path }) =>
    getRoute(path, {
      panelId: workspaceId,
      entityId: item?.id,
      tab: 'overview',
    })

  const linksActions = {
    topics: () => getLinkFromRoute({ path: PATHNAMES.WORKSPACE_TOPIC }),
    industry_topic: () => getLinkFromRoute({ path: PATHNAMES.INDUSTRY_CATEGORY }),
    subtopics: () => getLinkFromRoute({ path: PATHNAMES.WORKSPACE_SUBTOPIC }),
    tags: () => getLinkFromRoute({ path: PATHNAMES.WORKSPACE_TAG }),
    global_topic: () => getLinkFromRoute({ path: PATHNAMES.WORKSPACE_GLOBAL_TOPIC }),
    theme: () => getLinkFromRoute({ path: PATHNAMES.WORKSPACE_THEME }),
    segment: () => getLinkFromRoute({ path: PATHNAMES.WORKSPACE_SEGMENT }),
    subject: () => getLinkFromRoute({ path: PATHNAMES.WORKSPACE_SUBJECT }),
    entity_query: () => getLinkFromRoute({ path: PATHNAMES.WORKSPACE_ENTITY_QUERY }),
    entity: () => getLinkFromRoute({ path: PATHNAMES.WORKSPACE_ENTITY }),
    creators: () =>
      makeUrlTo.creator({
        creatorId: item?.id,
        groupId: item?.groupId,
        provider: item?.provider,
      }),
    default: () => '#',
  }

  const getLink = linksActions[item?.type] || linksActions['default']
  return getLink()
}

function CardContentBar({ item, index }) {
  const { removeItem } = useSelectedItemsList()
  const workspaceId = PanelStore?.selectedPanel?.panelId

  const typesWithBullet = [
    'topics',
    'subtopics',
    'savedPostSearches',
    'niches',
    'trendings',
    'tags',
    'industry_topic',
    'global_topic',
    ...GLOBAL_TAXONOMY_TERRITORY_TYPES,
  ]
  const currentUrl = getCurrentUrl(item, workspaceId)

  return (
    <li className="CardContentBar">
      {typesWithBullet.includes(item?.type) && (
        <div className="CardContentBar-bullet" style={{ backgroundColor: GRAPH_COLORS[index] }} />
      )}

      {item?.type === 'creators' && item?.thumbnail && (
        <div className="CardContentBar-thumbnail">
          <Image src={item?.thumbnail} alt={item?.name} width={34} height={34} />
        </div>
      )}

      <Link to={currentUrl}>
        <div className="CardContentBar-title">
          <Title tag="span" weight="regular">
            {item?.name}
          </Title>

          <CardSubtitle item={item} />
        </div>
      </Link>

      <div className="CardContentBar-removeIcon" onClick={() => removeItem(item)}>
        <Icon icon="smallClose" />
      </div>
    </li>
  )
}

export default memo(CardContentBar)
